// @flow

import createAction from 'redux-actions/lib/createAction';


// -----------------------------------------------------------------------------------------------------------------
// Actions
// -----------------------------------------------------------------------------------------------------------------

// updateCookieSettings
// --------------------

// Types…

export type ClearCookieNotAllowedModalPayload = {||};

export type ClearCookieNotAllowedModalAction = {|
  payload: ClearCookieNotAllowedModalPayload,
|}

export type ClearCookieNotAllowedModalActionFactory = () => ClearCookieNotAllowedModalAction;

// Action…

const clearCookieNotAllowedModal: ClearCookieNotAllowedModalActionFactory = createAction(
  'COOKIE_SETTINGS:COOKIE_BLOCKED_MODAL:CLEAR',
);


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default clearCookieNotAllowedModal;



// WEBPACK FOOTER //
// ./src/actions/cookieSettings/clearCookieNotAllowedModal.js